'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var taxonomyNodePropType = _propTypes2.default.shape({
  _id: _propTypes2.default.string,
  name: _propTypes2.default.string,
  geonameId: _propTypes2.default.number,
  type: _propTypes2.default.string,
  associated: _propTypes2.default.shape({
    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      key: _propTypes2.default.string,
      href: _propTypes2.default.string
    }))
  }),
  depth: _propTypes2.default.number
});

exports.default = taxonomyNodePropType;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PropTypes/taxonomyNodePropType.js
// module id = 42
// module chunks = 11